/**
 * BJCP styles database.
 */

export const STYLES = [
  // Bohemska & tyska lagers
  {
    id: '3A',
    category: 'Lager – Ljus',
    name: 'Bohemsk Pilsner',
    og_min: 1.044,
    og_max: 1.06,
    fg_min: 1.013,
    fg_max: 1.017,
    ibu_min: 30,
    ibu_max: 45,
    ebc_min: 7,
    ebc_max: 12,
    abv_min: 4.2,
    abv_max: 5.4,
  },
  {
    id: '5D',
    category: 'Lager – Ljus',
    name: 'Tysk Pilsner',
    og_min: 1.044,
    og_max: 1.05,
    fg_min: 1.008,
    fg_max: 1.013,
    ibu_min: 22,
    ibu_max: 40,
    ebc_min: 4,
    ebc_max: 10,
    abv_min: 4.4,
    abv_max: 5.2,
  },
  {
    id: '4A',
    category: 'Lager – Ljus',
    name: 'München Helles',
    og_min: 1.044,
    og_max: 1.048,
    fg_min: 1.006,
    fg_max: 1.012,
    ibu_min: 16,
    ibu_max: 22,
    ebc_min: 6,
    ebc_max: 10,
    abv_min: 4.7,
    abv_max: 5.4,
  },
  {
    id: '6A',
    category: 'Lager – Amber',
    name: 'Märzen / Oktoberfest',
    og_min: 1.054,
    og_max: 1.06,
    fg_min: 1.01,
    fg_max: 1.014,
    ibu_min: 18,
    ibu_max: 24,
    ebc_min: 16,
    ebc_max: 33,
    abv_min: 4.8,
    abv_max: 5.9,
  },
  {
    id: '6C',
    category: 'Lager – Mörk',
    name: 'Helles Bock / Maibock',
    og_min: 1.064,
    og_max: 1.072,
    fg_min: 1.011,
    fg_max: 1.018,
    ibu_min: 23,
    ibu_max: 35,
    ebc_min: 10,
    ebc_max: 20,
    abv_min: 6.3,
    abv_max: 7.4,
  },
  {
    id: '6B',
    category: 'Lager – Mörk',
    name: 'Traditionell Bock',
    og_min: 1.064,
    og_max: 1.072,
    fg_min: 1.013,
    fg_max: 1.019,
    ibu_min: 20,
    ibu_max: 27,
    ebc_min: 39,
    ebc_max: 59,
    abv_min: 6.3,
    abv_max: 7.2,
  },
  {
    id: '8A',
    category: 'Lager – Mörk',
    name: 'München Dunkel',
    og_min: 1.048,
    og_max: 1.056,
    fg_min: 1.01,
    fg_max: 1.016,
    ibu_min: 18,
    ibu_max: 28,
    ebc_min: 28,
    ebc_max: 55,
    abv_min: 4.5,
    abv_max: 5.6,
  },
  {
    id: '8B',
    category: 'Lager – Mörk',
    name: 'Schwarzbier',
    og_min: 1.046,
    og_max: 1.052,
    fg_min: 1.01,
    fg_max: 1.016,
    ibu_min: 20,
    ibu_max: 30,
    ebc_min: 37,
    ebc_max: 59,
    abv_min: 4.4,
    abv_max: 5.4,
  },
  {
    id: '9C',
    category: 'Lager – Mörk',
    name: 'Baltic Porter',
    og_min: 1.06,
    og_max: 1.09,
    fg_min: 1.016,
    fg_max: 1.024,
    ibu_min: 20,
    ibu_max: 40,
    ebc_min: 33,
    ebc_max: 79,
    abv_min: 6.5,
    abv_max: 9.5,
  },

  // Brittiska ales
  {
    id: '11A',
    category: 'Ale – Brittisk',
    name: 'Ordinary Bitter',
    og_min: 1.03,
    og_max: 1.039,
    fg_min: 1.007,
    fg_max: 1.011,
    ibu_min: 25,
    ibu_max: 35,
    ebc_min: 16,
    ebc_max: 28,
    abv_min: 3.2,
    abv_max: 3.8,
  },
  {
    id: '11B',
    category: 'Ale – Brittisk',
    name: 'Best Bitter',
    og_min: 1.04,
    og_max: 1.048,
    fg_min: 1.008,
    fg_max: 1.012,
    ibu_min: 25,
    ibu_max: 40,
    ebc_min: 16,
    ebc_max: 31,
    abv_min: 3.8,
    abv_max: 4.6,
  },
  {
    id: '11C',
    category: 'Ale – Brittisk',
    name: 'Strong Bitter / ESB',
    og_min: 1.048,
    og_max: 1.06,
    fg_min: 1.01,
    fg_max: 1.016,
    ibu_min: 30,
    ibu_max: 50,
    ebc_min: 16,
    ebc_max: 35,
    abv_min: 4.6,
    abv_max: 6.2,
  },
  {
    id: '14A',
    category: 'Ale – Brittisk',
    name: 'Scottish Heavy 70/-',
    og_min: 1.035,
    og_max: 1.04,
    fg_min: 1.01,
    fg_max: 1.015,
    ibu_min: 10,
    ibu_max: 20,
    ebc_min: 26,
    ebc_max: 43,
    abv_min: 3.2,
    abv_max: 3.9,
  },
  {
    id: '13C',
    category: 'Ale – Brittisk',
    name: 'English Porter',
    og_min: 1.04,
    og_max: 1.052,
    fg_min: 1.008,
    fg_max: 1.014,
    ibu_min: 18,
    ibu_max: 35,
    ebc_min: 39,
    ebc_max: 59,
    abv_min: 4.0,
    abv_max: 5.4,
  },
  {
    id: '17C',
    category: 'Ale – Brittisk',
    name: 'Old Ale',
    og_min: 1.055,
    og_max: 1.088,
    fg_min: 1.015,
    fg_max: 1.022,
    ibu_min: 30,
    ibu_max: 60,
    ebc_min: 22,
    ebc_max: 79,
    abv_min: 5.5,
    abv_max: 9.0,
  },
  {
    id: '17E',
    category: 'Ale – Brittisk',
    name: 'English Barleywine',
    og_min: 1.08,
    og_max: 1.12,
    fg_min: 1.018,
    fg_max: 1.03,
    ibu_min: 35,
    ibu_max: 70,
    ebc_min: 16,
    ebc_max: 43,
    abv_min: 8.0,
    abv_max: 12.0,
  },

  // Stout
  {
    id: '15A',
    category: 'Ale – Stout',
    name: 'Dry Irish Stout',
    og_min: 1.036,
    og_max: 1.044,
    fg_min: 1.007,
    fg_max: 1.011,
    ibu_min: 25,
    ibu_max: 40,
    ebc_min: 49,
    ebc_max: 79,
    abv_min: 4.0,
    abv_max: 4.5,
  },
  {
    id: '15B',
    category: 'Ale – Stout',
    name: 'Oatmeal Stout',
    og_min: 1.045,
    og_max: 1.065,
    fg_min: 1.01,
    fg_max: 1.018,
    ibu_min: 25,
    ibu_max: 40,
    ebc_min: 43,
    ebc_max: 79,
    abv_min: 4.2,
    abv_max: 5.9,
  },
  {
    id: '16D',
    category: 'Ale – Stout',
    name: 'Foreign Extra Stout',
    og_min: 1.056,
    og_max: 1.075,
    fg_min: 1.01,
    fg_max: 1.018,
    ibu_min: 30,
    ibu_max: 70,
    ebc_min: 59,
    ebc_max: 99,
    abv_min: 6.3,
    abv_max: 8.0,
  },
  {
    id: '20A',
    category: 'Ale – Stout',
    name: 'Russian Imperial Stout',
    og_min: 1.075,
    og_max: 1.115,
    fg_min: 1.018,
    fg_max: 1.03,
    ibu_min: 50,
    ibu_max: 90,
    ebc_min: 59,
    ebc_max: 99,
    abv_min: 8.0,
    abv_max: 12.0,
  },

  // Amerikanska ales
  {
    id: '18B',
    category: 'Ale – Amerikansk',
    name: 'American Pale Ale',
    og_min: 1.045,
    og_max: 1.06,
    fg_min: 1.01,
    fg_max: 1.015,
    ibu_min: 30,
    ibu_max: 50,
    ebc_min: 6,
    ebc_max: 14,
    abv_min: 4.5,
    abv_max: 6.2,
  },
  {
    id: '21A',
    category: 'Ale – Hoppy',
    name: 'American IPA',
    og_min: 1.056,
    og_max: 1.07,
    fg_min: 1.008,
    fg_max: 1.014,
    ibu_min: 40,
    ibu_max: 70,
    ebc_min: 12,
    ebc_max: 28,
    abv_min: 5.5,
    abv_max: 7.5,
  },
  {
    id: '21C',
    category: 'Ale – Hoppy',
    name: 'Hazy / NEIPA',
    og_min: 1.06,
    og_max: 1.085,
    fg_min: 1.01,
    fg_max: 1.015,
    ibu_min: 25,
    ibu_max: 60,
    ebc_min: 6,
    ebc_max: 14,
    abv_min: 6.0,
    abv_max: 9.0,
  },
  {
    id: '22A',
    category: 'Ale – Hoppy',
    name: 'Double IPA',
    og_min: 1.065,
    og_max: 1.1,
    fg_min: 1.008,
    fg_max: 1.018,
    ibu_min: 60,
    ibu_max: 120,
    ebc_min: 12,
    ebc_max: 28,
    abv_min: 7.5,
    abv_max: 10.0,
  },

  // Belgiska ales
  {
    id: '24A',
    category: 'Ale – Belgisk',
    name: 'Witbier',
    og_min: 1.044,
    og_max: 1.052,
    fg_min: 1.008,
    fg_max: 1.012,
    ibu_min: 8,
    ibu_max: 20,
    ebc_min: 4,
    ebc_max: 8,
    abv_min: 4.5,
    abv_max: 5.5,
  },
  {
    id: '25B',
    category: 'Ale – Belgisk',
    name: 'Saison',
    og_min: 1.048,
    og_max: 1.065,
    fg_min: 1.002,
    fg_max: 1.012,
    ibu_min: 20,
    ibu_max: 35,
    ebc_min: 10,
    ebc_max: 28,
    abv_min: 3.5,
    abv_max: 9.0,
  },
  {
    id: '26B',
    category: 'Ale – Belgisk',
    name: 'Belgian Dubbel',
    og_min: 1.062,
    og_max: 1.075,
    fg_min: 1.008,
    fg_max: 1.018,
    ibu_min: 15,
    ibu_max: 25,
    ebc_min: 20,
    ebc_max: 33,
    abv_min: 6.0,
    abv_max: 7.6,
  },
  {
    id: '26C',
    category: 'Ale – Belgisk',
    name: 'Belgian Tripel',
    og_min: 1.075,
    og_max: 1.085,
    fg_min: 1.008,
    fg_max: 1.014,
    ibu_min: 20,
    ibu_max: 40,
    ebc_min: 9,
    ebc_max: 14,
    abv_min: 7.5,
    abv_max: 9.5,
  },
  {
    id: '27A',
    category: 'Ale – Belgisk',
    name: 'Belgian Strong Dark',
    og_min: 1.075,
    og_max: 1.11,
    fg_min: 1.01,
    fg_max: 1.024,
    ibu_min: 20,
    ibu_max: 35,
    ebc_min: 24,
    ebc_max: 43,
    abv_min: 8.0,
    abv_max: 12.0,
  },

  // Veteöl
  {
    id: '10A',
    category: 'Ale – Vete',
    name: 'Hefeweizen',
    og_min: 1.044,
    og_max: 1.052,
    fg_min: 1.01,
    fg_max: 1.014,
    ibu_min: 8,
    ibu_max: 15,
    ebc_min: 6,
    ebc_max: 18,
    abv_min: 4.3,
    abv_max: 5.6,
  },
  {
    id: '10B',
    category: 'Ale – Vete',
    name: 'Dunkelweizen',
    og_min: 1.044,
    og_max: 1.056,
    fg_min: 1.01,
    fg_max: 1.014,
    ibu_min: 10,
    ibu_max: 18,
    ebc_min: 28,
    ebc_max: 45,
    abv_min: 4.3,
    abv_max: 5.6,
  },
  {
    id: '10C',
    category: 'Ale – Vete',
    name: 'Weizenbock',
    og_min: 1.064,
    og_max: 1.09,
    fg_min: 1.015,
    fg_max: 1.022,
    ibu_min: 15,
    ibu_max: 30,
    ebc_min: 14,
    ebc_max: 59,
    abv_min: 6.5,
    abv_max: 9.0,
  },
];
